export default __webpack_public_path__ + "static/media/78.bad8718e.png";